import * as React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { ChakraProvider } from "@chakra-ui/react";
import App from "./App";
import chakratheme from "./utils/theme";

import { PrimeReactProvider, PrimeReactContext } from "primereact/api";
import { ThemeProvider as MuiThemeProvider, createTheme } from "@mui/material/styles";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const theme = createTheme({
  palette: {
    mode: "light", // or "dark"
  },
});

root.render(
  <React.StrictMode>
    {/* <MuiThemeProvider theme={theme}> */}
    <ChakraProvider theme={chakratheme}>
      <PrimeReactProvider>
        <App />
      </PrimeReactProvider>
    </ChakraProvider>
    {/* </MuiThemeProvider> */}
  </React.StrictMode>
);

reportWebVitals();
